import { trackEvent } from 'dibs-tracking';

const notificationNameMap = {
    PENDING_FEEDBACK: 'review purchase',
};

export function getNotificationName(nodeType) {
    return notificationNameMap[nodeType];
}

export function trackNotification(label, action) {
    trackEvent({
        label,
        category: 'navigation',
        action: `header notifications notification ${action}`,
        noninteraction: 1,
        value: 0,
    });
}
